import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { map, tap } from 'rxjs';
import { FormFieldBase, FormFieldType } from 'src/app/common/components/dynamic-form-field/components/dynamic-form-light/models/form-field-base';
import { QuestionBase } from 'src/app/core/components/dynamic-form/models/question-base';
import { QuestionControlService } from 'src/app/core/components/dynamic-form/services/question-control.service';
import { OperationsService } from 'src/app/core/services/operations.service';
import { statusOpts } from '../../../costants/status-const';
import { PdaListaPagamentiRequest } from '../../../models/pda-lista-pagamenti-request';

@Component({
  selector: 'app-pagamenti-search',
  templateUrl: './pagamenti-search.component.html',
  styleUrls: ['./pagamenti-search.component.css']
})
export class PagamentiSearchComponent implements OnInit {

  @Output() searchEvent: EventEmitter<PdaListaPagamentiRequest> = new EventEmitter<PdaListaPagamentiRequest>();

  autoritaGiudiziariaSedeAutorita: any[] = [];
  questions: FormFieldBase[] = [];
  form: FormGroup = new FormGroup([]);

  constructor(private operationService: OperationsService,
    private qcs: QuestionControlService
  ){

  }

  ngOnInit(): void{
    // this.operationService
    //   .getAnagraficaAllElementsAttivi("autoritagiudiziariasedeautorita")
    //   .pipe(
    //     map((res) =>
    //       res.anagrafiche.filter(
    //         (anagrafica) => anagrafica.codiceUfficio != null
    //       )
    //     ),
    //     map((filteredAnagrafiche: any) => {
    //       filteredAnagrafiche = filteredAnagrafiche.filter((anagrafica) => anagrafica.autoritaGiudiziaria.label != "T.A.R.");
    //       return filteredAnagrafiche.map((anagrafica) => ({
    //         label:
    //           anagrafica.autoritaGiudiziaria.label +
    //           " - " +
    //           anagrafica.sedeTerritoriale.label,
    //         value: anagrafica.codiceUfficio,
    //       }));
    //     }),
    //     tap((res) => (this.autoritaGiudiziariaSedeAutorita = res))
    //   )
    //   .subscribe((res) => {
    //     this.questions = questions;
    //     this.autoritaGiudiziariaSedeAutorita = this.autoritaGiudiziariaSedeAutorita.sort((a,b) => (a.label.localeCompare(b.label)));
    //     this.questions.find(
    //       (question) => question.key === "officeCode"
    //     ).options = this.autoritaGiudiziariaSedeAutorita;
    //     this.form = this.qcs.toFormGroup(this.questions as QuestionBase[]);
    //   });
    this.questions = questions;
    this.form = this.qcs.toFormGroup(this.questions as QuestionBase[]);
  }

  onReset() {
    this.form.reset();
  }

  onSearch(){
    let req: PdaListaPagamentiRequest = new PdaListaPagamentiRequest();
    // req.codiceUfficio = this.form.controls['officeCode'].value;
    req.stato = this.form.controls['status'].value;
    req.richiestaDataDa = this.form.controls['requestDateFrom'].value;
    req.richiestaDataA = this.form.controls['requestDateTo'].value;
    this.searchEvent.emit(req);
  }

}

export const questions = [
  // {
  // controlType: FormFieldType[FormFieldType.SEARCHABLE_DROPDOWN],
  // key: "officeCode",
  // label: "Autorità giudiziaria - Sede",
  // placeholder: "Selezionare l'autorità giudiziaria",
  // chips: false,
  // disabled: false,
  // options: null,
  // required: false,
  // size: "col-sm-6"
  // },
  {
    controlType: FormFieldType[FormFieldType.DROPDOWN],
    key: "status",
    label: "Stato",
    placeholder: "Selezionare lo stato",
    chips: false,
    disabled: false,
    options: statusOpts,
    required: false,
    // size: "col-sm-6"
    size: "col-sm-4"
  },
  {
    controlType: FormFieldType[FormFieldType.DATE],
    key: "requestDateFrom",
    label: "Data Richiesta da",
    placeholder: "Selezionare la data di richiesta d'inizio",
    chips: false,
    disabled: false,
    required: false,
    // size: "col-sm-6"
    size: "col-sm-4"
  },
  {
    controlType: FormFieldType[FormFieldType.DATE],
    key: "requestDateTo",
    label: "Data Richiesta a",
    placeholder: "Selezionare la data di richiesta di fine",
    chips: false,
    disabled: false,
    required: false,
    // size: "col-sm-6"
    size: "col-sm-4"
  },
];
